<template>
  <div>
    <div class="text-h6 text-sm-h4 my-4">Родителям</div>

    <v-text-field
      v-model="searchMaterials"
      placeholder="Найти по материалам"
      append-icon="mdi-magnify"
      class="mb-4"
      flat
      solo
      hide-details
      clearable
      style="border: 1px solid #23919e; border-radius: 6px; max-width: 400px"
    ></v-text-field>

    <v-row>
      <v-col cols="12" md="6" class="pr-2 pr-md-3">
        <v-card class="parent-tool-card">
          <v-row no-gutters align="stretch">
            <v-col
              cols="12"
              md="4"
              class="d-flex align-center justify-center pa-3 pb-0"
            >
              <v-img
                src="./assets/lamp-icon.png"
                alt="Индивидуальные рекомендации"
                max-height="192"
                contain
                class="parent-card-img"
              ></v-img>
            </v-col>
            <v-col
              cols="12"
              md="8"
              class="pa-4 d-flex flex-column justify-center"
            >
              <h3 class="text-h5 mb-3">Индивидуальные рекомендации</h3>
              <p class="mb-4 text-body-2">
                Al рекомендации для конкретного ребенка
              </p>
              <v-btn
                color="#d86568"
                large
                rounded
                class="pa-5 px-sm-10 white--text"
                @click="goToRecommendation"
                max-width="250"
              >
                Сформировать
                <img src="./assets/stick.gif" alt="" class="btn-icon-right" />
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="pl-2 pl-md-3">
        <v-card class="parent-tool-card">
          <v-row no-gutters align="stretch">
            <v-col
              cols="12"
              md="4"
              class="d-flex align-center justify-center pa-3 pb-0"
            >
              <v-img
                src="./assets/video-materials-icon.png"
                alt="Видео и материалы"
                max-height="192"
                contain
                class="parent-card-img"
              ></v-img>
            </v-col>
            <v-col
              cols="12"
              md="8"
              class="pa-4 d-flex flex-column justify-center"
            >
              <h3 class="text-h5 mb-3">Видео и материалы</h3>
              <p class="mb-4 text-body-2">Видео, презентации, отзывы</p>
              <v-btn
                color="#d86568"
                large
                rounded
                class="pa-5 px-sm-10 white--text"
                @click="goToVideoMaterials"
                max-width="250"
              >
                Перейти
                <img src="./assets/stick.gif" alt="" class="btn-icon-right" />
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "CompanyParentsView",
  data() {
    return {
      searchMaterials: "",
    };
  },
  methods: {
    getSegmentFromRoute() {
      const name = this.$route.name || "";
      if (name.includes("adults")) return "adults";
      if (name.includes("children")) return "children";
      return null;
    },
    goToRecommendation() {
      const segment = this.getSegmentFromRoute();
      const userRole = this.$store.state.user?.role;
      if (userRole === "admin") {
        const name = segment
          ? `admin-parents-${segment}-recommendation`
          : "admin-parents-recommendation";
        this.$router.push({ name });
      } else if (userRole === "manager") {
        const name = segment
          ? `manager-parents-${segment}-recommendation`
          : "manager-parents-recommendation";
        this.$router.push({ name });
      } else if (userRole === "company-user" || userRole === "company-owner") {
        const name = segment
          ? `company-parents-${segment}-recommendation`
          : "company-parents-recommendation";
        this.$router.push({ name });
      }
    },
    goToVideoMaterials() {
      const segment = this.getSegmentFromRoute();
      const userRole = this.$store.state.user?.role;
      if (userRole === "admin") {
        const name = segment
          ? `admin-parents-${segment}-video-and-materials`
          : "admin-video-and-materials";
        this.$router.push({ name });
      } else if (userRole === "manager") {
        const name = segment
          ? `manager-parents-${segment}-video-and-materials`
          : "manager-video-and-materials";
        this.$router.push({ name });
      } else if (userRole === "company-user" || userRole === "company-owner") {
        const name = segment
          ? `company-parents-${segment}-video-and-materials`
          : "company-video-and-materials";
        this.$router.push({ name });
      }
    },
  },
};
</script>

<style scoped>
.parent-tool-card {
  min-height: 180px;
  max-width: 670px;
}

.parent-card-img {
  border-radius: 8px;
}

.btn-icon-right {
  height: 20px;
  width: auto;
  margin-left: 8px;
  vertical-align: middle;
}
</style>
